import React, { useState } from "react";
import classNames from "classnames";
import { getOtherProperties } from "../common/Utils";
import Icon from "../Icon";
import { SearchBarProps } from "./PropsType";

export default function SearchBar(props: SearchBarProps) {
  const {
    className,
    maxLength,
    autoFocus = false,
    cancelText = "取消",
    disabled = false,
    placeholder = "输入关键字...",
    prefixCls = "bm-SearchBar",
    ...other
  } = props;
  const [focus, setFocus] = useState(!!props.autoFocus);
  const [value, setValue] = useState(props.defaultValue || "");

  const styleClass = classNames(
    prefixCls,
    {
      [`${prefixCls}-active`]: focus,
    },
    className
  );
  const clearClass = classNames(`${prefixCls}-clear`, {
    [`${prefixCls}-clear-show`]: !!(value && focus),
  });
  const otherProps: object = getOtherProperties(other, [
    "onCancel",
    "onChange",
    "onBlur",
    "onFocus",
    "onSubmit",
  ]);

  const handleChange = (event: any) => {
    const target = event.target;
    if (target && target.value) {
      setValue(target.value);
      if (props.onChange) {
        (props.onChange as (event: any) => void)(target.value);
      }
    }
  };

  const handleFocus = () => {
    setFocus(true);
    if (props.onFocus) {
      (props.onFocus as () => void)();
    }
  };

  const handleBlur = () => {
    setFocus(false);
    if (props.onBlur) {
      (props.onBlur as () => void)();
    }
  };

  const handleSubmit = (event: any) => {
    const target = event.target;
    if (event.keyCode === 13 && props.onSubmit) {
      (props.onSubmit as (event: any) => void)(target.value);
    }
  };

  const handleCancel = () => {
    handleBlur();
    if (props.onCancel) {
      (props.onCancel as () => void)();
    }
  };
  return (
    <div className={styleClass} {...otherProps}>
      <a className={`${prefixCls}-cancel`} onClick={handleCancel}>
        {cancelText}
      </a>
      <div className={`${prefixCls}-input`}>
        <label htmlFor="SearchBar">
          <Icon icon="search" />
        </label>
        <input
          autoFocus={autoFocus}
          type="text"
          id="SearchBar"
          onChange={handleChange}
          disabled={disabled}
          onKeyUp={handleSubmit}
          onFocus={handleFocus}
          onBlur={handleBlur}
          maxLength={maxLength}
          value={value}
          placeholder={placeholder}
        />
        <a className={clearClass} />
      </div>
    </div>
  );
}
